import PropTypes from 'prop-types';
import React from 'react';

import BackstagePodcastProgramContinueListening from './BackstagePodcastProgramContinueListening';
import BackstagePodcastProgramRecentEpisodes from './BackstagePodcastProgramRecentEpisodes/BackstagePodcastProgramRecentEpisodes';
import BackstagePodcastProgramThumbedEpisodes from './BackstagePodcastProgramThumbedEpisodes';

const BackstagePodcastProgramAvailableEpisodeContent = props => {
  return (
    <React.Fragment>
      <BackstagePodcastProgramContinueListening programId={props.programId} />
      <BackstagePodcastProgramRecentEpisodes programId={props.programId} />
      <BackstagePodcastProgramThumbedEpisodes programId={props.programId} />
    </React.Fragment>
  );
};

BackstagePodcastProgramAvailableEpisodeContent.propTypes = {
  programId: PropTypes.string.isRequired,
};

export default BackstagePodcastProgramAvailableEpisodeContent;
